export default "__VITE_ASSET__DJ8GrmoZ__"